import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Form, FormGroup, FormLabel, Modal, ModalBody, ModalFooter, ModalHeader} from "react-bootstrap";
import Loader from "@/components/global/loader";
import {numberFormat} from "@/app/number";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";
import FormCheckInput from "react-bootstrap/FormCheckInput";
import styles from "./purchase-modal.module.scss";
import {CLEAR_PURCHASE} from "@/actions/types";
import PurchaseService from "@/services/purchase-service";

function PurchaseModal() {
  const [loading, setLoading] = useState(true);
  const postId = useSelector((state: any) => state.purchase.postId);
  const dispatch = useDispatch();
  const [purchaseInfo, setPurchaseInfo] = useState<IPurchaseInfo | null>();

  useEffect(() => {
    if(!postId)
      return;
    setLoading(true);
    PurchaseService.getInfo(postId)(dispatch).then((info: IPurchaseInfo) => {
      setPurchaseInfo({...info});
    }).catch(() => {
      setPurchaseInfo(null);
    }).finally(() => setLoading(false));
  }, [dispatch, postId]);

  const closeModal = () => {
    dispatch({
      type: CLEAR_PURCHASE
    });
  };

  const changeIncludeWallet = (iw: boolean) => {
    setPurchaseInfo({
      ...(purchaseInfo || {
        price: 0,
        walletBalance: 0
      }),
      includeWallet: iw
    });
  }

  const pay = () => {
    PurchaseService.purchase(postId, purchaseInfo?.includeWallet || false)(dispatch);
  };

  return <Modal show={postId} className={styles.purchaseModal}>
    <ModalHeader>خرید</ModalHeader>
        <ModalBody>
          {loading ? <div className="p-4"><Loader /></div> : purchaseInfo ? (
          <Form>
            <FormGroup>
              <strong>قیمت آگهی</strong>
              <FormLabel>{numberFormat(purchaseInfo.price || 0)} تومان</FormLabel>
            </FormGroup>
            <FormGroup>
              <strong>موجودی</strong>
              <FormLabel>{numberFormat(purchaseInfo.walletBalance || 0)} تومان</FormLabel>
            </FormGroup>
            {purchaseInfo.walletBalance > 0 ? (
                <FormGroup>
                  <FormCheckLabel className={styles.includeWallet}>
                    <FormCheckInput checked={purchaseInfo.includeWallet} onChange={e => changeIncludeWallet(e.target.checked)} />{ ' ' }
                    از موجودی حساب کسر شود
                  </FormCheckLabel>
                </FormGroup>
            ) : ''}
          </Form>
          ) : (
              <h6 className="text-danger">اطلاعاتی برای نمایش وجود ندارد</h6>
          )}
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={pay} disabled={loading}>پرداخت</button>
          <button className="btn btn-danger" onClick={closeModal}>انصراف</button>
        </ModalFooter>
    </Modal>;
}

export default PurchaseModal;
